import { physiciansRouteStore } from '../domain/store';
import { physicianUpsertModalRouteStore } from '../components/physician-upsert-modal/domain/store';

export default () => {
  physicianUpsertModalRouteStore.setInitialState();
  physiciansRouteStore.setValue('activePhysicianId', null);
  physiciansRouteStore.setValue('showingPhysicianUpsertModal', false);
};
